
import { Link } from "react-router-dom";

const Footer = () => {
  return <footer className="bg-white border-t mt-12">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center">
              <img 
                src="/lovable-uploads/df781da3-4e85-4cba-bd1c-86be3b12b486.png" 
                alt="LabSwAPP Logo" 
                className="h-8 mr-2" 
              />
            </Link>
            <p className="mt-3 text-gray-600 text-sm">
              A marketplace for swapping chemical reagents between university labs and institutions.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold text-gray-800 mb-3">Platform</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/reagents" className="text-gray-600 hover:text-reagent-blue">Browse Reagents</Link></li>
              <li><Link to="/reagents/new" className="text-gray-600 hover:text-reagent-blue">Upload Reagent</Link></li>
              <li><Link to="/help" className="text-gray-600 hover:text-reagent-blue">How It Works</Link></li>
              <li><Link to="/help" className="text-gray-600 hover:text-reagent-blue">FAQ</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-gray-800 mb-3">Account</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/login" className="text-gray-600 hover:text-reagent-blue">Login</Link></li>
              <li><Link to="/signup" className="text-gray-600 hover:text-reagent-blue">Sign Up</Link></li>
              <li><Link to="/profile" className="text-gray-600 hover:text-reagent-blue">My Profile</Link></li>
              <li><Link to="/my-reagents" className="text-gray-600 hover:text-reagent-blue">My Reagents</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold text-gray-800 mb-3">Contact</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="text-gray-600 hover:text-reagent-blue">Contact Form</Link></li>
              <li><Link to="/help" className="text-gray-600 hover:text-reagent-blue">Help Center</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} ReagentSwap. All rights reserved. Verification code: OS7K3L
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="/terms" className="text-sm text-gray-500 hover:text-reagent-blue">Terms of Service</Link>
            <Link to="/privacy" className="text-sm text-gray-500 hover:text-reagent-blue">Privacy Policy</Link>
          </div>
        </div>
      </div>
    </footer>;
};

export default Footer;
